/* Pawable buy box v2 controller.
   State: selected tier radio + subscribe checkbox → hidden variant id + selling_plan
   inputs, price-mode class, CTA price pair, sessionStorage persistence, ?pill= override. */
(function () {
  var form = document.getElementById('PawableBundleForm');
  if (!form) return;

  var pills = form.querySelector('[data-pawable-pills]');
  var variantInput = form.querySelector('#PawableBundleVariantId');
  var planInput = form.querySelector('#PawableSellingPlanInput');
  var subToggle = form.querySelector('[data-pawable-subscribe-toggle]');
  var ctaPrice = form.querySelector('[data-pawable-cta-price]');
  var ctaCompare = form.querySelector('[data-pawable-cta-compare]');
  var radios = Array.prototype.slice.call(form.querySelectorAll('[data-pawable-tier]'));
  if (!radios.length) return;

  var storageKey = 'pawable-tier-' + (form.getAttribute('action') || '') + window.location.pathname;

  var formatMoney = function (cents) {
    try {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
      });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  var selectedRadio = function () {
    return radios.filter(function (r) { return r.checked; })[0] || radios[0];
  };

  var subscribed = function () {
    return !!(subToggle && subToggle.checked && planInput);
  };

  var sync = function () {
    var radio = selectedRadio();
    variantInput.value = radio.getAttribute('data-variant-id');

    if (planInput) {
      planInput.value = subscribed() ? radio.getAttribute('data-plan-id') || '' : '';
      planInput.disabled = !subscribed();
    }

    var freqLabel = form.querySelector('[data-pawable-freq-label]');
    if (freqLabel) {
      var planName = radio.getAttribute('data-plan-name');
      if (planName) freqLabel.textContent = planName;
    }

    if (pills) pills.classList.toggle('pawable-mode-sub', subscribed());

    radios.forEach(function (r) {
      r.closest('.pawable-pills__option').classList.toggle('is-selected', r === radio);
    });

    var price = parseInt(subscribed() ? radio.getAttribute('data-price-sub') : radio.getAttribute('data-price-once'), 10);
    var compare = parseInt(radio.getAttribute('data-compare-at'), 10) || 0;
    if (ctaPrice) ctaPrice.textContent = formatMoney(price);
    if (ctaCompare) {
      if (compare > price) {
        ctaCompare.textContent = formatMoney(compare);
        ctaCompare.hidden = false;
      } else {
        ctaCompare.hidden = true;
      }
    }

    // Keep the sticky bar's price in step with the selected tier + subscribe state
    var stickyPrice = document.querySelector('.pawable-sticky-atc__price');
    if (stickyPrice) {
      stickyPrice.textContent = formatMoney(price);
    }
    var stickyTitle = document.querySelector('.pawable-sticky-atc__title');
    if (stickyTitle && radio.closest('.pawable-pills__option')) {
      var tierName = radio.closest('.pawable-pills__option').querySelector('.pawable-pills__title');
      if (tierName) {
        var base = stickyTitle.getAttribute('data-base-title') || stickyTitle.textContent.trim();
        stickyTitle.setAttribute('data-base-title', base);
        stickyTitle.textContent = base + ' · ' + tierName.textContent.trim();
      }
    }

    try {
      sessionStorage.setItem(storageKey, radio.getAttribute('data-tier-index'));
    } catch (e) { /* private mode */ }
  };

  // Restore tier: ?pill=first|last|N wins, then sessionStorage, then server default.
  var restore = function () {
    var pick = null;
    var param = new URLSearchParams(window.location.search).get('pill');
    if (param === 'first') pick = 1;
    else if (param === 'last') pick = radios.length;
    else if (param && !isNaN(parseInt(param, 10))) pick = parseInt(param, 10);
    else {
      try {
        var stored = sessionStorage.getItem(storageKey);
        if (stored) pick = parseInt(stored, 10);
      } catch (e) { /* private mode */ }
    }
    if (pick) {
      var target = radios.filter(function (r) {
        return parseInt(r.getAttribute('data-tier-index'), 10) === pick && !r.disabled;
      })[0];
      if (target) target.checked = true;
    }
  };

  radios.forEach(function (r) { r.addEventListener('change', sync); });
  if (subToggle) subToggle.addEventListener('change', sync);

  restore();
  sync();

  // AJAX add-to-cart: post through Dawn's section-rendering flow so the slide-out
  // drawer opens in place instead of navigating to the cart page. Falls back to a
  // normal form submit if the drawer isn't on the page.
  form.addEventListener('submit', function (event) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cart || typeof cart.renderContents !== 'function') return; // native submit fallback

    event.preventDefault();
    var submitBtn = form.querySelector('[data-pawable-add-to-cart]');
    if (submitBtn) {
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.disabled = true;
    }

    var formData = new FormData(form);
    if (typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (s) { return s.id; })
      );
      formData.append('sections_url', window.location.pathname);
    }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) {
          // Shopify error (e.g. sold out) — fall back to native navigation for messaging
          form.submit();
          return;
        }
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        cart.renderContents(state);
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.removeAttribute('aria-busy');
          submitBtn.disabled = false;
        }
      });
  });
})();
